/*
* @Author: gujianghua
* @Date:   2020-11-17 14:49:20
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-11-17 15:05:39
*/
export default {
	video(name) {
		name = name.toLocaleLowerCase()
		return /.+\.(mp4|wmv|avi|mkv|flv|swf)$/i.test(name)
	},

	audio(name) {
		name = name.toLocaleLowerCase()
		return /.+\.(mp3|wav|wma|amr)$/i.test(name)
	},

	img(name) {
		name = name.toLocaleLowerCase()
		return /.+\.(jpg|jpeg|png|gif|bmp)$/i.test(name)
	},

	type(name) {
		if(this.video(name)) { return '视频' }
		if(this.audio(name)) { return '音频' }
		if(this.img(name)) { return '图片' }
		else { return '文本' }
	}
}
	


// WEBPACK FOOTER //
// ./src/utils/verify.js